import UserInterface from 'app/interfaces/UserInterface';
import {action, makeObservable, observable} from 'mobx';
import $ from 'jquery';
import {ArtifactStore} from 'app/store/ArtifactStore';
import {SteamTradeStore} from 'app/store/SteamTradeStore';
import {StoriesStore} from 'app/store/StoriesStore';
import BonusInterface from 'app/interfaces/BonusInterface';
import Get from 'app/utils/Get';
import {getLinkPath} from 'app/utils';
import {toastErrorNotify, toastSuccess} from 'app/components/toasts/liteToast';
import I18n from 'app/i18n';
import {fixed2} from 'app/utils/fixed';
import Post from 'app/utils/Post';
import {showDocumentsUploadPopup} from 'app/components/DocumentsUpload/upload_documents';
import {UserBonusesStore} from './UserBonusesStore';
import Cookies from 'js-cookie';
import {NotificationSettingsStore} from './NotificationSettingsStore';
import {CashoutsStore, CashoutsFormInterface} from './CashoutsStore';
import {IncubatorShiftStore} from './IncubatorShiftStore';

const TIME_DIVIDER = 1000;

export interface userStoreInterface {
    userStore?: UserStore
}

interface UpdateInterface {
    user?: UserInterface,
    messagesCount?: number
}

interface ConstructorData {
    artifactStore: ArtifactStore
    steamTradeStore: SteamTradeStore
    userBonusesStore: UserBonusesStore
    notificationSettingsStore: NotificationSettingsStore
    cashoutsStore: CashoutsStore
    incubatorShiftStore: IncubatorShiftStore
}

interface IncubatorPresetsInterface {
    coef_changing: number
    consider_personal_limits: boolean
    delay_for_bets_time: number
    hide_creator: boolean
}

export class UserStore {
    artifactStore: ArtifactStore;

    steamTradeStore: SteamTradeStore;

    storiesStore: StoriesStore;

    @observable user: UserInterface = {
        accept_any_coef: null,
        active_bets_count: null,
        active_bets_sum: null,
        artifact_bet: false,
        balance: null,
        banned: false,
        beer_and_gift_promo_disabled: null,
        bet_stats: null,
        bonus_balance: null,
        bonuses: null,
        bonuses_disabled: null,
        can_change_password: true,
        cashback_real_rate: null,
        cashback_remaining_balance: null,
        cashout_enabled: null,
        casino_disabled: null,
        casino_first_bet: null,
        chat_name_color_enabled: null,
        closed: false,
        confirmation_period_expired: null,
        confirmed: null,
        cool_off: {
            end_date: null,
            marketing_activity: false,
            period: null,
            present: false,
            product_type: null
        },
        country: null,
        country_code: null,
        coupon_close: null,
        created_at: null,
        current_ip_country: 'xx',
        day_of_birth: {
            day: null,
            month: null,
            year: null
        },
        demo: false,
        demo_balance: null,
        deposit_enabled: null,
        email: null,
        enable_incubator: false,
        enable_incubator2: false,
        experimental_features: false,
        first_bet: null,
        first_deposit: null,
        first_name: null,
        frozen_balances: null,
        full_balance: null,
        full_registered: null,
        fullname: null,
        giveaway_took_part: null,
        giveaway_turnover: false,
        group: null,
        hot_icon_lootbox_enabled: true,
        id: null,
        incubator_bets_rate: null,
        incubator_last_game_id: null,
        incubator_lines_ids: [],
        invalid_email: false,
        is_admin: false,
        last_name: null,
        light_mode: true,
        marketing_consent: null,
        message_notification: false,
        messages_count: null,
        name: null,
        notifications: null,
        phone: null,
        play_money: null,
        points: null,
        poker_enabled: null,
        profile_image: null,
        public_inventory: null,
        public_inventory_link: null,
        referral_link: '',
        registered_via_steam: false,
        restrict_artifact: null,
        site_lang: null,
        sound_enabled: Number(Cookies.get('volume')) > 0,
        steam_account: {
            steam_avatar_url: null,
            steam_id: null,
            steam_linked_at: null,
            steam_username: null
        },
        telegram_linked_at: null,
        telegram_user_id: null,
        telegram_username: null,
        terms: null,
        time_zone: {
            full_name: 'UTC',
            int: null,
            name: 'UTC',
            t: Math.trunc(Date.now() / TIME_DIVIDER)
        },
        timezone_id: null,
        token: null,
        trade_enabled: null,
        trade_link: null,
        trade_token_link: null,
        unknown_country_code: null,
        user_id: null,
        verified_status: null,
        warning_message: false
    };

    @observable messagesCount = 0;

    subscription = null;

    constructor(data: UpdateInterface, constuctorData: ConstructorData) {
        this.artifactStore = constuctorData.artifactStore;
        this.steamTradeStore = constuctorData.steamTradeStore;

        makeObservable(this);

        this.update(data);
        constuctorData.userBonusesStore.setUserStore(this);

        if (data?.user?.id) {
            this.loadAdditionalData(constuctorData);
            constuctorData.incubatorShiftStore.setupChannel(data.user.id);
        }
    }

    @action
    updateIncubatorLastGame(game_id: number): void {
        this.user.incubator_last_game_id = game_id;
    }

    @action
    addIncubatorLineId(id: number): void {
        this.user.incubator_lines_ids = this.user.incubator_lines_ids.concat(id);
    }

    @action update({user, messagesCount}: UpdateInterface): void {
        if (typeof messagesCount !== 'undefined') {
            this.messagesCount = messagesCount;
        }
        if (typeof user !== 'undefined') {
            this.user = {
                ...this.user,
                ...user
            };
        }
    }

    @action
    updateBonuses(bonuses: BonusInterface[]): void {
        this.user.bonuses = bonuses;
    }

    @action
    updateProfileImage(image: string): void {
        this.user.profile_image = image;
    }

    @action
    updateFirstBet(status: boolean): void {
        this.user.first_bet = status;
        this.storiesStore.updateOnboardingStories();
    }

    @action
    updateHotIconStatus(status: boolean): void {
        this.user.hot_icon_lootbox_enabled = status;
    }

    @action
    updateIncubatorInitialPresets(newInitialPresets: IncubatorPresetsInterface): void {
        this.user.incubator_initial_presets = newInitialPresets;
    }

    frozenBalanceToast(amount: string): void {
        toastSuccess(I18n.t('frozen_added', {amount: fixed2(Number(amount))}));
    }

    changeUserHotIconStatus(): void {
        if (this.user.hot_icon_lootbox_enabled) {
            $.ajax('/user/update_hot_icon_status', {
                method: 'POST',
                success: data => this.updateHotIconStatus(data.status)
            });
        }
    }

    fullRegistered(): boolean {
        return this.user.full_registered;
    }

    unknownCountryCode(): boolean {
        const {unknown_country_code} = this.user;
        return unknown_country_code === null
            ? true
            : unknown_country_code;
    }

    updateProfile = (): void => {
        new Get({url: getLinkPath('/my_profile')})
            .execute()
            .then(data => data.json())
            .then(data => this.update({user: data}));
    };

    updateVerificationNotification = (): void => {
        new Post({
            params: {user: {notified_about_verification: true}},
            url: '/user'
        }).execute();
    };

    isIncubatorLineCreator = (lineId: number): boolean => this.user.incubator_lines_ids.includes(lineId);

    listen(payload: UserInterface): void {
        if (payload.banned || payload.closed) {
            window.location.reload();
        }
        this.update({user: payload});
    }

    notifyIfNeedVerified(): void {
        const {verified_status, notified_about_verification} = this.user;

        if (verified_status === 'need_verify' && !notified_about_verification) {
            toastErrorNotify(I18n.t('user.need_verification'), {
                onClick: () => {
                    showDocumentsUploadPopup();
                    this.updateVerificationNotification();
                },
                onClose: () => {
                    this.updateVerificationNotification();
                }
            });
        }
    }

    @action
    loadAdditionalData(constructorData: ConstructorData): void {
        const {userBonusesStore,
            notificationSettingsStore,
            cashoutsStore,
            incubatorShiftStore} = constructorData;
        new Get({url: '/my_profile/additional_data'})
            .execute()
            .then(data => data.json())
            .then(data => {
                this.update({user: data.user.data});
                this.artifactStore.updateTradeEnabled({
                    trade_enabled: this.user.trade_enabled,
                    trade_token_link: data.user.data.trade_token_link
                });
                this.artifactStore.updateStore({...data.artifacts});
                this.steamTradeStore.updateStore(data.steam_trades);
                notificationSettingsStore.init(data.user.notification_settings);
                cashoutsStore.update({} as CashoutsFormInterface, data.user.p2p_cashouts_in_waiting);
                userBonusesStore.updateBonusDataLoading(false);
                userBonusesStore.updateStore({...data.bonuses_data});
                userBonusesStore.setFreeSpins(data.free_spins);
                this.updateBonuses(data.bonuses_data.bonuses);
                userBonusesStore.showNotViewedBonusPopup();
                incubatorShiftStore.init(data.incubator_shifts);
            });
    }
}
